import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useListingBuyerSearchData } from '@steelbuy/data-provider';
import { ButtonGhostSystemOnLightM, CardClear, IconIdentifier, SearchSummaryActions } from '@steelbuy/ui-primitive';
import { SearchListingsSearchSummary } from './SearchListingsSearchSummary';
import { RoutePath } from '../../router/Routes';
import { useSearchFormDataContext } from '../listing-search/SearchFormDataContext';

export const SearchListingsSummary = () => {
    const listingSearchData = useListingBuyerSearchData();
    const navigate = useNavigate();
    const { t } = useTranslation('translation');
    const searchFormData = useSearchFormDataContext().getSearchFormData();

    return (
        <CardClear isClickable={false}>
            <div className="search-listings-summary">
                <SearchListingsSearchSummary searchFormData={searchFormData}>
                    <SearchSummaryActions>
                        <ButtonGhostSystemOnLightM
                            title={t('application.listingSearchResults.editSearchButtonTitle')}
                            icon={IconIdentifier.EDIT}
                            onClick={() => {
                                listingSearchData.resolveFetchStatus();
                                navigate(RoutePath.SEARCH_LISTINGS);
                            }}
                        />
                    </SearchSummaryActions>
                </SearchListingsSearchSummary>
            </div>
        </CardClear>
    );
};
